/** @file Scale tool pointer: shared transform press with the scale gizmo. */
import type { ToolPointer } from '../../panels/viewport/viewportTypes';
import { scaleGesture } from '../transform/scaleGesture';
import { transformIdle } from '../transform/transformIdle';
import { transformPress } from '../transform/transformPress';

/** Uniform disc and X/Y discs on the bone's world X. */
export const scalePointer: ToolPointer = { press: (ctx, p) => transformPress(ctx, p, 'scale', scaleGesture), idle: (ctx) => transformIdle(ctx, 'scale') };
